import React from 'react';
import HeroAppDownload from '../HeroAppDownload';
import Page from '../Page';
import { NO_TOP_AD } from '../Page/Templates';

const description = 'Download the GasBuddy App for free and start saving immediately on your next visit to the gas station. Fuel better using our app for savings, rewards & more!';
const title = 'GasBuddy™ App - Find Cheaper Gas Prices & Save Up to 25¢/Gallon';

export default function AppPage() {
  return (
    <Page
      name="App_Page"
      compact
      title={title}
      description={description}
      {...NO_TOP_AD}
    >
      <HeroAppDownload useH1Header />
    </Page>
  );
}
